import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { newGuid } from "helpers/guid";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Minus } from "UI/Icons";
import { FlexibleTextArea } from "UI/Inputs";
import MatrixBlock from "./MatrixBlock";

var MatrixParagraph = /*#__PURE__*/function (_Component) {
  _inherits(MatrixParagraph, _Component);

  var _super = _createSuper(MatrixParagraph);

  function MatrixParagraph(props) {
    var _this;

    _classCallCheck(this, MatrixParagraph);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.disableNotAchieved) {
        var rows = _this.state.rows;
        rows.forEach(function (row) {
          var searchNotAchieved = row.cells.find(function (co) {
            return co.gradeF == true;
          });

          if (searchNotAchieved == null) {
            var id = newGuid();
            var stepId = newGuid();
            var gradeF = {
              id: stepId,
              text: _this.props.translate("not-achieved"),
              gradeF: true
            };
            row.cells.unshift(gradeF);
          }
        });
        _this.setState(rows), function () {
          _this.sendToForm();
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBlockAdd", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.props.onParagraphBlockAdd({
        id: _this.props.paragraph.id,
        title: _this.state.title,
        subtitle: _this.state.subtitle,
        paragraphNr: _this.state.paragraphNr,
        rows: _this.state.rows
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlockUpdate", function (block) {
      var rows = _this.state.rows;
      var matrixBlock = rows.find(function (t) {
        return t.id == block.id;
      });
      matrixBlock.text = block.text;
      matrixBlock.cells = block.cells;

      _this.setState({
        rows: rows
      }, function () {
        _this.sendToForm();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlockDelete", function (block) {
      if (event != null) {
        event.preventDefault();
      }

      var rows = _this.state.rows;
      rows = rows.filter(function (t) {
        return t.id != block.id;
      });
      var isEmpty = true;
      var rowIndex = 0;
      rows.forEach(function (Row) {
        isEmpty = false;
        rowIndex = rowIndex + 1;
        Row.sentenceNr = rowIndex;
        return Row;
      });

      _this.setState({
        rows: rows
      }, function () {
        _this.sendToForm();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphTitleAdd", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.hasTitle = true;

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphSubTitleAdd", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.hasSubtitle = true;

      _this.setState({});
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphTitleChange", function (text) {
      var title = text;

      _this.setState({
        title: title
      }, function () {
        _this.sendToForm();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphSubTitleChange", function (text) {
      var subtitle = text;

      _this.setState({
        subtitle: subtitle
      }, function () {
        _this.sendToForm();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphDelete", function (event) {
      _this.props.onParagraphDelete({
        id: _this.props.paragraph.id,
        title: _this.state.title,
        subtitle: _this.state.subtitle,
        paragraphNr: _this.state.paragraphNr,
        rows: _this.state.rows
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sendToForm", function () {
      _this.props.onParagraphUpdate({
        id: _this.props.paragraph.id,
        title: _this.state.title,
        subtitle: _this.state.subtitle,
        paragraphNr: _this.state.paragraphNr,
        rows: _this.state.rows
      });
    });

    _this.state = {
      id: props.paragraph.id != null ? props.paragraph.id : newGuid(),
      title: props.paragraph.title != null ? props.paragraph.title : "",
      subtitle: props.paragraph.subtitle != null ? props.paragraph.subtitle : "",
      paragraphNr: props.paragraph.paragraphNr,
      rows: props.paragraph.rows != null ? props.paragraph.rows : []
    };
    _this.disableNotAchieved = props.disableNotAchieved;
    _this.hasTitle = props.paragraph.title != null && props.paragraph.title != "";
    _this.hasSubtitle = props.paragraph.subtitle != null && props.paragraph.subtitle != "";
    return _this;
  }

  _createClass(MatrixParagraph, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "3rem"
        },
        key: "paragraph-".concat(this.props.paragraph.paragraphNr)
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }), /*#__PURE__*/React.createElement("strong", null, this.props.translate("core-section"), " ", this.props.paragraph.paragraphNr), /*#__PURE__*/React.createElement("span", {
        onClick: this.onParagraphDelete,
        style: {
          flexShrink: "0",
          cursor: "pointer",
          margin: "0 1em",
          marginLeft: "3em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "15px",
          display: "inline-block",
          position: "right",
          top: "2px",
          marginRight: "0.5em"
        }
      }, /*#__PURE__*/React.createElement(Minus, null)), this.props.translate("delete-section")), this.hasTitle ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: "1"
        }
      }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
        value: this.state.title != null ? this.state.title : "",
        placeholder: this.props.translate("heading"),
        onChange: function onChange(event) {
          return _this2.onParagraphTitleChange(event.target.value);
        }
      }))) : /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "courses-add-btn",
        onClick: function onClick(e) {
          return _this2.onParagraphTitleAdd(e);
        }
      }, "+ L\xE4gg till ", this.props.translate("heading"))), this.hasSubtitle ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: "1"
        }
      }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
        value: this.state.subtitle != null ? this.state.subtitle : "",
        placeholder: this.props.translate("subtitle"),
        onChange: function onChange(event) {
          return _this2.onParagraphSubTitleChange(event.target.value);
        }
      }))) : /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "courses-add-btn",
        onClick: function onClick(e) {
          return _this2.onParagraphSubTitleAdd(e);
        }
      }, "+ L\xE4gg till ", this.props.translate("subtitle"))), this.state.rows.map(function (block, i) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: "1rem"
          },
          key: block.id
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            fontWeight: 500,
            marginBottom: "0.4em",
            fontSize: "0.85em",
            display: "block"
          }
        }, "Block ", i + 1), /*#__PURE__*/React.createElement(MatrixBlock, {
          key: block.id,
          block: block,
          onBlockUpdate: _this2.onBlockUpdate.bind(_this2),
          onBlockDelete: _this2.onBlockDelete.bind(_this2)
        }));
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "courses-add-btn",
        onClick: function onClick(e) {
          return _this2.onBlockAdd(event);
        }
      }, "+ ", this.props.translate("add-block"))), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }));
    }
  }]);

  return MatrixParagraph;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(MatrixParagraph);